require("../sass/critical.scss");


(function ($) {
    const isMobile = window.innerWidth <= 1024;
    $(".header").length > 0 && require("./template_parts/header.es6");
    $(".kits-hero").length > 0 && require("./template_parts/kits_hero.es6");
    require("./general/aos.es6");

    if (!isMobile) {
        require("./general/lenis.es6");
      }


    const splitText = $(".split-text");
    if (splitText) {
        splitText.each(function () {
            const _this = $(this);
            const textArr = _this.html().split(" ");
            _this.text("");

            let line = 1;
            let lastOffsetTop = null;

            textArr.forEach(function (word, index) {
                if (word === "<br>") {
                    const span = document.createElement("span");
                    span.classList.add('brl')
                    _this.append(span);
                    return;
                }

                if (word === "|") {
                    const span = document.createElement("span");
                    span.classList.add('brl')
                    _this.append(span);
                    return;
                }

                const span = document.createElement("span");
                const span_inner = document.createElement("span");

                $(span).addClass("split-anim");
                $(span_inner).addClass("split-anim__inner");
                span_inner.textContent = word;
                span.append(span_inner);
                _this.append(span);

                const empt = document.createElement("span");
                $(empt).text(" ");
                _this.append(empt);

                const currentOffsetTop = span.offsetTop;

                if (lastOffsetTop === null) {
                    lastOffsetTop = currentOffsetTop;
                } else if (currentOffsetTop > lastOffsetTop) {
                    line++;
                    lastOffsetTop = currentOffsetTop;
                }

                $(span_inner).addClass(`count-${line}`);
            });
        });
    }
})(jQuery);



